import { render, staticRenderFns } from "./DetailHeaderControls.vue?vue&type=template&id=1a707522&scoped=true"
import script from "./DetailHeaderControls.vue?vue&type=script&lang=js"
export * from "./DetailHeaderControls.vue?vue&type=script&lang=js"
import style0 from "./DetailHeaderControls.vue?vue&type=style&index=0&id=1a707522&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a707522",
  null
  
)

export default component.exports